import { addRasterOverlay, removeRasterOverlay } from '../raster_helpers';

const weatherId = 'weather';

const addWeather = map => {
  const apiKey = 'be324f17c1d64e11b24f17c1d63e1136';
  const fifteenMin = 1000 * 60 * 15;
  const date = new Date().getTime();
  const fifteenFloorTimestamp = new Date(Math.floor(date / fifteenMin) * fifteenMin).getTime() / 1000;
  const fifteenCeilTimestamp = new Date(Math.ceil(date / fifteenMin) * fifteenMin).getTime() / 1000;
  addRasterOverlay(
    map,
    weatherId,
    `https://api.weather.com/v3/TileServer/tile/satradFcst?ts=${fifteenFloorTimestamp}&fts=${fifteenCeilTimestamp}&xyz={x}:{y}:{z}&apiKey=${apiKey}`,
    {
      attribution: "<a target='_blank' href='https://www.weather.com/'>Weather.com</a>",
      tileSize: 256
    },
    {
      paint: {
        'raster-opacity': 0.5
      }
    }
  );
};

const removeWeather = map => {
  removeRasterOverlay(map, weatherId);
};

export { addWeather, removeWeather };
